import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from "../lib/api";
import toast from 'react-hot-toast';

const PROFILE_KEY = ['companyProfile'];

export const useCompanyProfile = () => {
    const queryClient = useQueryClient();

    const { data: profile, isLoading, error } = useQuery({
        queryKey: PROFILE_KEY,
        queryFn: () => api.get('/company/profile').then(res => res.data.data),
        staleTime: 1000 * 60 * 5,
        onError: () => {
            toast.error('Failed to load company profile');
        },
    });

    const updateMutation = useMutation({
        mutationFn: (data) => api.put('/company/profile', data),
        onSuccess: (response) => {
            queryClient.setQueryData(PROFILE_KEY, { data: response.data.data });
            queryClient.invalidateQueries(PROFILE_KEY);
            toast.success('Company profile updated successfully!');
        },
        onError: (error) => {
            const message = error.response?.data?.message || 'Failed to update profile';
            toast.error(message);
        },
    });

    return {
        profile,
        isLoading,
        error,
        updateProfile: updateMutation.mutate,
        isUpdating: updateMutation.isPending,
    };
};